import script from "./HelpCenter.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelpCenter.vue?vue&type=script&setup=true&lang=ts"

import "../style/HelpCenter.css?vue&type=style&index=0&id=5956c2d9&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5956c2d9"]])

export default __exports__